import { call, put, takeLatest } from "redux-saga/effects"

import ErrorsActions from "../../Redux/ErrorsRedux"
import { apiGeneratorBase } from "../../Utils/saga"
import Creators, { BusinessDetailsTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getBusinessDetailsActions: {
    request: Creators.getBusinessDetailsRequest,
    success: Creators.getBusinessDetailsSuccess
  },
  updateBusinessDetailsActions: {
    request: Creators.updateBusinessDetailsRequest,
    success: Creators.updateBusinessDetailsSuccess
  },
  getCountriesActions: {
    request: Creators.getCountriesRequest,
    success: Creators.getCountriesSuccess
  }
}

const eventsOptions = {
  [constants.GET_BUSINESS_DETAILS_REQUEST]: {
    api: services.getBusinessDetails,
    actions: actions.getBusinessDetailsActions
  },
  [constants.UPDATE_BUSINESS_DETAILS_REQUEST]: {
    api: services.updateBusinessDetails,
    actions: actions.updateBusinessDetailsActions
  },
  [constants.GET_COUNTRIES_REQUEST]: {
    api: services.getCountries,
    actions: actions.getCountriesActions
  }
}

function* updateBusinessDetailsAction(action, provider) {
  const { meta, body, params } = action.payload
  const response = yield call(provider.api, { body, params })
  if (response.ok) {
    yield put(provider.actions.success(response?.data))
    meta?.onSuccess(response?.data)
  } else {
    const error = response.data
    meta?.onError(error)
    yield put(ErrorsActions.errorSave(response.status === 500 ? "Server response error" : error))
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_BUSINESS_DETAILS_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_BUSINESS_DETAILS_REQUEST])
  )
  yield takeLatest(constants.UPDATE_BUSINESS_DETAILS_REQUEST, (action) =>
    updateBusinessDetailsAction(action, eventsOptions[constants.UPDATE_BUSINESS_DETAILS_REQUEST])
  )
  yield takeLatest(constants.GET_COUNTRIES_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_COUNTRIES_REQUEST])
  )
}
